import { BaseApiRepository } from "@/core/infrastructure/BaseApiRepository";
import { InstrumentRepository } from "../domain/repositories/InstrumentRepository";
import {
  InstrumentCreateRequest,
  InstrumentUpdateRequest,
  ResponseInstrument,
  ResponseInstrumentKV,
} from "../domain/entities/InstrumentEntity";
import { ResponseInstrumentTypes } from "@/modules/dashboard/domain/entities/DashboardEntity";

export class InstrumentApiRepository extends BaseApiRepository implements InstrumentRepository {
  async getAllInstruments(): Promise<ResponseInstrumentKV> {
    return await this.request<ResponseInstrumentKV>(`/api/instruments`);
  }

  async getInstrumentById(id: string): Promise<ResponseInstrumentKV> {
    return await this.request<ResponseInstrumentKV>(`/api/instruments/${id}`);
  }

  async createInstrument(instrument: InstrumentCreateRequest): Promise<ResponseInstrument> {
    const result = await this.request<ResponseInstrument>("/api/instruments", {
      method: "POST",
      body: JSON.stringify(instrument),
    });

    await new Promise((r) => setTimeout(r, 2000));
    return result;
  }

  async updateInstrument(instrument: InstrumentUpdateRequest): Promise<ResponseInstrument> {
    return await this.request<ResponseInstrument>(`/api/instruments/${instrument.id}`, {
      method: "PUT",
      body: JSON.stringify(instrument),
    });
  }

  async deleteInstrument(id: string): Promise<ResponseInstrument> {
    return await this.request<ResponseInstrument>(`/api/instruments/${id}`, {
      method: "DELETE",
    });
  }


  async getAllInstrumentTypes(): Promise<ResponseInstrumentTypes> {
    return await this.request<ResponseInstrumentTypes>(`/api/instrumentTypes`);
  }
}
